module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loginError) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.loginError))])]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Login")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six columns"
  }, [_c('label', {
    attrs: {
      "for": "login-username"
    }
  }, [_vm._v("Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginUsername),
      expression: "loginUsername"
    }],
    staticClass: "u-full-width",
    attrs: {
      "id": "login-username",
      "name": "username",
      "type": "text",
      "placeholder": "username"
    },
    domProps: {
      "value": (_vm.loginUsername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginUsername = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "six columns"
  }, [_c('label', {
    attrs: {
      "for": "login-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginPassword),
      expression: "loginPassword"
    }],
    staticClass: "u-full-width",
    attrs: {
      "id": "login-password",
      "name": "password",
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.loginPassword)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "twelve columns"
  }, [_c('a', {
    staticClass: "button",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/forgot"
    }
  }, [_vm._v("Forgot Password")])], 1)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [(_vm.registerError) ? _c('p', [_vm._v(_vm._s(_vm.registerError))]) : _vm._e()]), _vm._v(" "), _c('h3', [_vm._v("Register")]), _vm._v(" "), (!_vm.canRegister) ? _c('div', [_vm._v("\n    You have successfully registered an account and can log in\n  ")]) : _vm._e(), _vm._v(" "), (_vm.canRegister) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six columns"
  }, [_c('label', {
    attrs: {
      "for": "register-username"
    }
  }, [_vm._v("Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registerUsername),
      expression: "registerUsername"
    }],
    staticClass: "u-full-width",
    attrs: {
      "id": "register-username",
      "type": "text",
      "placeholder": "username"
    },
    domProps: {
      "value": (_vm.registerUsername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registerUsername = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "six columns"
  }, [_c('label', {
    attrs: {
      "for": "register-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registerPassword),
      expression: "registerPassword"
    }],
    staticClass: "u-full-width",
    attrs: {
      "id": "register-password",
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.registerPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registerPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six columns"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registerEmail),
      expression: "registerEmail"
    }],
    staticClass: "u-full-width",
    attrs: {
      "id": "register-email",
      "type": "email",
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.registerEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registerEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "six columns"
  }, [_c('label', {
    attrs: {
      "for": "register-password"
    }
  }, [_vm._v("Invitation Token")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invitationToken),
      expression: "invitationToken"
    }],
    staticClass: "u-full-width",
    attrs: {
      "id": "register-token",
      "type": "text",
      "placeholder": "token"
    },
    domProps: {
      "value": (_vm.invitationToken)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.register($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invitationToken = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "twelve columns"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("Register")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "register-password"
    }
  }, [_vm._v("Email "), _c('small', [_vm._v("(For account recovery)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4aec1052"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 273
// module chunks = 1